module.exports = __webpack_public_path__ + "img/sign-out-white.41e744d6.svg";